export const useTenkiNews = async () => {
  const config = useRuntimeConfig()
  let retInfo = ''

  const api = config.public.tenkiNewsApi
  retInfo = await getJsonData(api)

  return retInfo
}
